"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listDatabaseClusterBackups = void 0;
const listDatabaseClusterBackups = ({ httpClient, }) => ({ page = 1, per_page = 25, database_cluster_id, }) => {
    const path = '/databases';
    const query_params = { page, per_page };
    const url = `${path}/${database_cluster_id}/backups`;
    return httpClient.get(url, { params: query_params });
};
exports.listDatabaseClusterBackups = listDatabaseClusterBackups;
//# sourceMappingURL=list-database-cluster-backups.js.map